import React, { Component } from 'react';
import '../custom.css';
import imageLogo from '../img/logo.png';
import imageNBA from '../img/nba.png';
import functionMin from '../js/functions-min.js';
//import functions from '../js/functions.js';
import jqueryMin from '../lib/jquery/jquery-2.2.4.min.js';
import statsDatalistHandler from '../lib/jquery/statsDatalistHandler.js';
import AllPlayers from './AllPlayers';
import $ from 'jquery';
import { Bar } from 'react-chartjs-2';
import Chart from 'chart.js/auto';
import Gametoolbar from './Games/GamesToolbar';

export class Home extends React.Component {

    static displayName = Home.name;

    render() {

        return (
            <div>
                <div className="perspective effect-rotate-left">
                    <div className="props">
                        <div className="outer-nav--return"></div>
                        <div id="viewport" className="l-viewport">
                            <div className="l-wrapper">
                                <header className="header">
                                    <a className="header--logo" href="/">
                                        <img src={imageLogo} alt="Global"/>
                                            <p>NPA</p>
                                    </a>
                                    <button className="header--cta cta">Analyze</button>
                                </header>
                                <nav className="l-side-nav">
                                    <ul className="side-nav">
                                        <li className="is-active"><span>Home</span></li>
                                        <li><span>Analyze</span></li>
                                    </ul>
                                </nav>
                                <ul className="l-main-content main-content">
                                    <li className="l-section section section--is-active">
                                        <div className="intro">
                                            <div className="intro--banner">
                                                <h1>NBA<br/>Props<br/>Analyzer</h1>
                                                <button className="cta">
                                                    Continue
                                                    <span className="btn-background"></span>
                                                </button>
                                                <img height="400" width="400" src={imageNBA} alt="Welcome"/>
                                            </div>
                                            <div className="intro--options">
                                                <a href="#0">
                                                    <h3>Analyze</h3>
                                                    <p>Find your edge.</p>
                                                </a>
                                                <a href="#0">
                                                    <h3>Bet</h3>
                                                    <p>May the odds be in your favor.</p>
                                                </a>
                                                <a href="#0">
                                                    <h3>Win</h3>
                                                    <p>That's the goal!</p>
                                                </a>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="l-section section">
                                        
                                        <div className="propOptions">
                                       
                                            <Gametoolbar />
                                            <h2 className="propLabel">Pick your Prop</h2>
                                            <form action={`/stats/`} className="work-request" id="Props">
                                            <div className="work-request--options">
                                                <span className="options-a">
                                                    <input id="points" name="points" type="checkbox" value="true" />
                                                    <label htmlFor="points">
                                                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                        viewBox="0 0 150 111" xmlSpace="preserve">
                                                            <g transform="translate(0.000000,111.000000) scale(0.100000,-0.100000)">
                                                                <path d="M950,705L555,310L360,505C253,612,160,700,155,700c-6,0-44-34-85-75l-75-75l278-278L550-5l475,475c261,261,475,480,475,485c0,13-132,145-145,145C1349,1100,1167,922,950,705z" />
                                                            </g>
                                                        </svg>
                                                        Points
                                                    </label>
                                                        <input id="rebounds" name="rebounds" type="checkbox" value="true" />
                                                    <label htmlFor="rebounds">
                                                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                        viewBox="0 0 150 111"  xmlSpace="preserve">
                                                            <g transform="translate(0.000000,111.000000) scale(0.100000,-0.100000)">
                                                                <path d="M950,705L555,310L360,505C253,612,160,700,155,700c-6,0-44-34-85-75l-75-75l278-278L550-5l475,475c261,261,475,480,475,485c0,13-132,145-145,145C1349,1100,1167,922,950,705z" />
                                                            </g>
                                                        </svg>
                                                        Rebounds
                                                    </label>
                                                    <input id="assists" name="assists" type="checkbox" value="true" />
                                                    <label htmlFor="assists">
                                                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                        viewBox="0 0 150 111"  xmlSpace="preserve">
                                                            <g transform="translate(0.000000,111.000000) scale(0.100000,-0.100000)">
                                                                <path d="M950,705L555,310L360,505C253,612,160,700,155,700c-6,0-44-34-85-75l-75-75l278-278L550-5l475,475c261,261,475,480,475,485c0,13-132,145-145,145C1349,1100,1167,922,950,705z" />
                                                            </g>
                                                        </svg>
                                                        Assists
                                                    </label>
                                                </span>
                                                <span className="options-a">
                                                    <input id="pr" type="checkbox" name="pr" value="true" />
                                                    <label htmlFor="pr">
                                                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                        viewBox="0 0 150 111"  xmlSpace="preserve">
                                                            <g transform="translate(0.000000,111.000000) scale(0.100000,-0.100000)">
                                                                <path d="M950,705L555,310L360,505C253,612,160,700,155,700c-6,0-44-34-85-75l-75-75l278-278L550-5l475,475c261,261,475,480,475,485c0,13-132,145-145,145C1349,1100,1167,922,950,705z" />
                                                            </g>
                                                        </svg>
                                                        Pts+Rebs
                                                    </label>
                                                    <input id="pa" type="checkbox" name="pa" value="true" />
                                                    <label htmlFor="pa">
                                                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                        viewBox="0 0 150 111" xmlSpace="preserve">
                                                            <g transform="translate(0.000000,111.000000) scale(0.100000,-0.100000)">
                                                                <path d="M950,705L555,310L360,505C253,612,160,700,155,700c-6,0-44-34-85-75l-75-75l278-278L550-5l475,475c261,261,475,480,475,485c0,13-132,145-145,145C1349,1100,1167,922,950,705z" />
                                                            </g>
                                                        </svg>
                                                        Pts+Asts
                                                    </label>
                                                    <input id="pra" type="checkbox" name="pra" value="true" />
                                                    <label htmlFor="pra">
                                                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                        viewBox="0 0 150 111" xmlSpace="preserve">
                                                            <g transform="translate(0.000000,111.000000) scale(0.100000,-0.100000)">
                                                                <path d="M950,705L555,310L360,505C253,612,160,700,155,700c-6,0-44-34-85-75l-75-75l278-278L550-5l475,475c261,261,475,480,475,485c0,13-132,145-145,145C1349,1100,1167,922,950,705z" />
                                                            </g>
                                                        </svg>
                                                        Pts+Rebs+Asts
                                                    </label>                                            
        
                                                </span>
                                            </div>
                                            <center><p>Player Name</p></center>
                                            <AllPlayers/>
                                            <input className="cta" type="submit" id="submit" value="Submit"/>
                                            </form>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


